import { createApp } from "vue";
import ArticleHomepage from "./ArticleHomepage.vue";

const app = createApp({
  components: {
    "article-homepage": ArticleHomepage,
  },
}).mount("#container-article-homepage");
